import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loading } from "src/components";
import { UIService } from "src/services";
import { Pages, PagesAction } from "src/store";

export const PackageGuide: React.FC = () => {

    //#region dependencies

    const dispatch = useDispatch();
    const pages: Pages = useSelector((state: any) => state.PagesState);
    const isEmbedded = UIService.isEmbedded();


    //#end region

    //#region effects

    useEffect(() => {

        if (!pages.packageGuide.loaded) {
            dispatch(PagesAction.requestPackageGuide());
        }

    }, [dispatch, pages.packageGuide.loaded]);

    //#end region

    return (
        <div className="page-about-us app-theme2">
            {!isEmbedded &&
                <div className="cover d-flex">
                    <div className="container d-flex">
                        <h1>
                            <span>{pages.packageGuide.title}</span>
                        </h1>
                    </div>
                </div>
            }
            <div className="container content pb-5">
                {isEmbedded && <h1 className="text-rtl page-title">{pages.packageGuide.title}</h1>}
                {
                    !pages.packageGuide.loaded &&
                    <div className="container program-page app-theme2 p-0 p-md-2 py-4 my-4">
                        <div className="py-4 my-4">
                            <Loading />
                        </div>
                    </div>
                }
                <div dangerouslySetInnerHTML={{ __html: pages.packageGuide.htmlBody }}></div>
            </div>
        </div>
    );
};